import { Component, OnInit, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { QuickLink } from '../../../services/quick-links.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-quick-links-search-modal',
  templateUrl: './quick-links-search-modal.component.html',
  styleUrls: ['./quick-links-search-modal.component.scss']
})
export class QuickLinksSearchModalComponent implements OnInit {
  searchControl = new FormControl('');
  quickLinks: QuickLink[] = [];
  filteredQuickLinks: Observable<QuickLink[]>;

  constructor(
    public dialogRef: MatDialogRef<QuickLinksSearchModalComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) data: { quickLinks: QuickLink[] }
  ) {
    this.quickLinks = data.quickLinks;
  }

  ngOnInit(): void {
    this.filteredQuickLinks = this.searchControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );
  }

  private _filter(value: string): QuickLink[] {
    const filterValue = value.toLowerCase();
    return this.quickLinks.filter(link =>
      link.description.toLowerCase().includes(filterValue) ||
      link.key.toLowerCase().includes(filterValue)
    );
  }

  activateQuickLink(quickLink: QuickLink): void {
    if (quickLink.action) {
      quickLink.action();
    } else if (quickLink.route) {
      this.router.navigate([quickLink.route]);
    }
    this.dialogRef.close();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
